// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2UMya","label":"Labeled_label__2aSYr","divider":"Labeled_divider__2Pmzf"};